import { Block } from '@shared/models';

export const listingCategoriesFacadesMock: Block<null> = {
  type: 'listing-categories-facades',
  data: null,
};
